import styled, { css } from 'styled-components';
import {
  mq,
  getFixedSpace,
  borderShape,
  backgroundShape,
  getSpace
} from '../../../stylesheets/tools';

const StyledEventFilterTags = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .eventFilterTags__tag {
    position: relative;
    margin-right: 10px;
    margin-top: ${getSpace('xxs')};
    cursor: pointer;
    color: #000;

    ${props =>
      props.theme.siteTheme &&
      css`
        ${backgroundShape('#fff', props.theme.siteTheme.primary, '#000')}
        &:hover {
          ${backgroundShape('#fff', props.theme.siteTheme.primary, '#000')}
        }
      `}

    ${props =>
      props.inverted &&
      css`
        ${borderShape('#000')}
      `}

    ${props =>
      props.border &&
      css`
        ${borderShape()}
      `}
    &:last-of-type {
      margin-right: 0;
    }

    ${props =>
      props.alignRight &&
      css`
        margin-left: 10px;
        margin-right: 0;
      `}
  }

  .eventFilterTags__tag--active {
    ${props =>
      props.theme.siteTheme &&
      css`
        ${backgroundShape(props.theme.siteTheme.primary, '#fff', '#000')};
      `}
  }

  span {
    cursor: pointer;
    pointer-events: none;
    display: flex;
    align-items: center;
    position: relative;
    padding: 10px ${getFixedSpace('xxs')};
    line-height: 22px;
    font-size: 20px;
    text-transform: uppercase;
    ${borderShape()}

    ${mq('m')} {
      line-height: 22px;
      font-size: 22px;
    }

    &:last-of-type {
      margin-right: 0;
    }

    svg {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      fill: #000;
    }
  }
`;
export default StyledEventFilterTags;
